import moment from 'moment';
import { WEBSITE_URL } from '../constants/APIConstants';
import ky from './kyextended';



export const getShopifyAutomationData = ({webId, start_date, end_date}) => ky.post(`${WEBSITE_URL}${webId}/shopify-automation/` , {
    json: {
        start_date: moment.utc(start_date).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        end_date: moment.utc(end_date).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
    },
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

export const updateShopifyAutomationData = (webId, payload) => ky.patch(`${WEBSITE_URL}${webId}/shopify-automation/`, {
    json: payload,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

export const getAbandonedCartData = (webKey) => ky.get(`${WEBSITE_URL}${webKey}/shopify/abandoned-cart/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

export const updateAbandonedCartData = (webKey, abandonedCartData) => ky.patch(`${WEBSITE_URL}${webKey}/shopify/abandoned-cart/`, {
    body: abandonedCartData,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

export const getBackInStockData = (webKey) => ky.get(`${WEBSITE_URL}${webKey}/shopify/back-in-stock/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

export const updateBackInStockData = (webKey, backInStockData) => ky.patch(`${WEBSITE_URL}${webKey}/shopify/back-in-stock/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    },
    json: backInStockData,
}).json();

export const getPriceDropData = (webKey) => ky.get(`${WEBSITE_URL}${webKey}/shopify/price-drop/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

export const updatePriceDropData = (webKey, priceDropData) => ky.patch(`${WEBSITE_URL}${webKey}/shopify/price-drop/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    },
    json: priceDropData,
}).json();

export const getShippingAlertData = (webKey) => ky.get(`${WEBSITE_URL}${webKey}/shopify/shipping-alert/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json()

export const updateShippingAlertData = (webKey, shippingAlertData) => ky.patch(`${WEBSITE_URL}${webKey}/shopify/shipping-alert/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    },
    json: shippingAlertData,
}).json();